import React from 'react'

function Footer() {
  return (
    <section className="as_footer_wrapper as_padderTop80">
    <div className="container">
        <div className="row">
            <div className="col-lg-12">
                <div className="as_know_sign_wrapper as_padderBottom50 as_padderTop100">
                    <div className="row">
                        <div className="col-lg-4">
                            <h1 className="as_heading as_heading_center">Zodiac Sign Finder</h1>
                        </div>   
                        <div className="col-lg-8">
                            <div className="as_sign_form text-left">
                                <ul> 
                                    <li className="as_form_box">
                                        <div className="as_input_feild as_select_box">
                                            <select className="form-control" data-placeholder="Date">
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select>
                                        </div>
                                    </li>
                                    <li className="as_form_box">
                                        <div className="as_input_feild as_select_box">
                                            <select className="form-control" data-placeholder="Month">
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                            </select>
                                        </div>
                                    </li>
                                    <li className="as_form_box">
                                        <div className="as_input_feild as_select_box">
                                            <select className="form-control" data-placeholder="Year">
                                                <option value="1994">1994</option>
                                                <option value="1995">1995</option>
                                                <option value="1996">1996</option>
                                                <option value="1997">1997</option>
                                                <option value="1998">1998</option>
                                            </select>
                                        </div> 
                                    </li>
                                    <li className="as_form_box">
                                        <a href="javascript:;" className="as_btn">Submit</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                

                <div className="as_footer_inner as_padderTop10 as_padderBottom40">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="as_footer_widget">
                                <div className="as_footer_logo">
                                    <a href="/"><img src="assets/images/logo.8119d31cf7380532ba8b.png" alt=""/></a>
                                </div>
                                <p>Empowering your journey through astrology's lens - Astro Gurijii!</p>

                                <ul className="as_contact_list">
                                    <li>
                                        <img src="assets/images/svg/map.svg" alt=""/>
                                        <p>Lucknow 226010, Uttar Pradesh, India</p>
                                    </li>
                                    <li>
                                        <img src="assets/images/svg/phone.svg" alt=""/>
                                        <p>
                                            <a href="javascript:;">+ (91) 8172888061</a>
                                        </p>
                                    </li>
                                    <li>
                                        <img src="assets/images/svg/mail.svg" alt=""/>
                                        <p>
                                            <a href="javascript:;">info@astrogurujii.com</a>
                                        </p> 
                                    </li> 
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="as_footer_widget">
                            <h3 className="as_footer_heading">Quick Links</h3>

                            <ul>
                                <li><a href="/about"> About Us</a></li>
                                <li><a href="/"> Blog</a></li>
                                <li><a href="/"> Astrologers</a></li>
                                <li><a href="/"> Appointment</a></li>
                                <li><a href="/contact"> Contact Us</a></li>
                            </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="as_footer_widget">
                            <h3 className="as_footer_heading">Horoscope Forecasts</h3>

                            <ul>
                                <li><a href="/"> My Daily Horoscope</a></li>
                                <li><a href="/"> My Weekly Horoscope</a></li>
                                <li><a href="/privacy_policy">Privacy Policy</a></li>
                                <li><a href="/refundandcalcellation"> Refund and Cancellation Policy </a></li>
                                <li><a href="/termsandconditions"> Terms and Conditions</a></li>
                            </ul>
                            </div>
                        </div>
                        
                        
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="as_footer_widget">
                            <h3 className="as_footer_heading">Our Newsletter</h3>

                            <p>Fresh insights and trends tailored for you. </p>

                            <div className="as_newsletter_wrapper">
                                    <div className="as_newsletter_box">
                                        <input type="text" name="" id="" className="form-control" placeholder="Email..."/>
                                        <a href="javascript:;" className="as_btn">
                                            <img src="assets/images/svg/plane.svg" alt=""/>
                                        </a>
                                    </div>
                                </div>

                                <div className="as_login_data">
                                    <label>I agree that my submitted data is
                                        being collected and stored.
                                        <input type="checkbox" name="as_remember_me" value=""/>
                                        <span className="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="as_copyright_wrapper text-center">
                    <p>Copyright &copy; 2022 Astrogurujii. All Right Reserved.</p>
                </div> 
            </div>
        </div>
    </div>
</section>
  )
}

export default Footer